

class GrossToNetService {


  static colDefs = [
    { field: 'sourceMapLabel',  initialWidth: 112 },
    
    { field: "sourceMapDesc" },
    { field: "sourceMapId" },
    { field: "sourceMapTypeId" },
    { field: "tenantId" },
    { field: "isAutoProcess" },
    { field: "hostServerName" },
    { field: "username" },
    { field: "password" },
    { field: "port" },
    { field: "protocolType" },
    { field: "ftpArchiveFolder" },
    { field: "rootDirectory" },
    { field: "isExternalUpload" },
    { field: "csvDelimiter" },
    { field: "active" },
    { field: "startTime" },
    { field: "endTime" },
    { field: "emailTo" },
    { field: "emailCc" },
    { field: "emailBcc" },
    { field: "createdBy" },
    { field: "createdDate" },
    { field: "updatedBy" },
    { field: "updatedDate" },
    { field: "mefDependency" },
 
  ];


};
export default GrossToNetService;